import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import isExternalUrl from 'commons/isExternalUrl';

import normalizeInternalLink from 'commons/normalizeInternalLink';
import useIsBrowser from 'hooks/useIsBrowser';

// This is the secondary navigation menu shown on pages such as Shipping,
// Returns and Warranty. Ideally this should be renamed to a more accurate name,
// and the exported name (used in layouts.json) should be updated accordingly.
const ConsumerMenu = props => {
  const isBrowser = useIsBrowser();

  const { isAltSubMenu } = props;
  let finalMenuList = props.config.navlinks.map(links =>
    isExternalUrl(links.link) ? (
      <a
        key={links.link}
        href={links.link}
        className="text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3 no-underline hover:underline font-bold"
      >
        {links.title}
      </a>
    ) : (
      <Link
        key={links.link}
        className={cx('font-bold no-underline hover:underline', {
          'text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3': true,
          'text-brand': isBrowser && window.location.pathname === links.link,
        })}
        to={normalizeInternalLink(links.link)}
      >
        {links.title}
      </Link>
    )
  );
  if (isAltSubMenu) {
    // This is the alternative / second menu layout with icons
    // I have only added the list here please add the required icons
    finalMenuList = props.config.navlinks.map(links =>
      isExternalUrl(links.link) ? (
        <a
          key={links.link}
          href={links.link}
          className="text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3 no-underline hover:underline font-bold"
        >
          {links.title}
        </a>
      ) : (
        <Link
          key={links.link}
          className={cx('font-bold no-underline hover:underline', {
            'text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3': true,
            'text-brand': isBrowser && window.location.pathname === links.link,
          })}
          to={normalizeInternalLink(links.link)}
        >
          {links.title}
        </Link>
      )
    );
  }
  return (
    <div className="[border-bottom:1px_solid_#e5e5e5]">
      <div className="flex justify-start whitespace-nowrap max-w-[1400px] px-5 py-0 overflow-auto [border-top:1px_solid_#f1f1f1] lg:[border-top:0] lg:px-[3.333vw] lg:py-0 min-[1440px]:overflow-hidden [&_a:first-child]:ml-0 max-[767px]:overflow-auto max-[767px]:flex-nowrap [&::-webkit-scrollbar]:max-[767px]:hidden">
        {finalMenuList}
      </div>
    </div>
  );
};

ConsumerMenu.propTypes = {
  config: PropTypes.shape({
    borderBottom: PropTypes.bool,
    navlinks: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.string,
      })
    ),
  }),
  isAltSubMenu: PropTypes.bool,
};

export default ConsumerMenu;
